/* istanbul ignore file */
import React from 'react';
import ListFilterWrapper from './ListFilterWrapper';
import { SxProps } from '@mui/system';
import { Paper } from '@mui/material';
import { pageContentSx } from '../../../ui/layout/pageLayoutSx';

interface ListPageLayoutProps {
  header?: React.ReactElement;
  filter?: React.ReactElement;
  actions?: React.ReactElement[];
  children?: React.ReactElement | React.ReactElement[];
  search?: React.ReactElement;
  showTotal?: boolean;
  sxPaper?: SxProps;
  sxFilter?: SxProps;
  alwaysOpen?: boolean;
  useDropdown?: boolean;
}

const ListPageLayout = ({
  header,
  filter,
  actions,
  children,
  search,
  sxPaper,
  sxFilter,
  alwaysOpen = false,
  useDropdown = false,
}: ListPageLayoutProps) => {
  return (
    <>
      <ListFilterWrapper
        filter={filter}
        search={search}
        actions={actions}
        sx={sxFilter}
        alwaysOpen={alwaysOpen}
        useDropdown={useDropdown}
      />
      <Paper className="page-content" sx={{ ...pageContentSx, ...(sxPaper || { p: 2 }) }} data-hj-suppress>
        {header}
        {children}
      </Paper>
    </>
  );
};

export default ListPageLayout;
